import { Zap } from 'lucide-react'
import { useHistory } from 'react-router'

type InstantConsultationBannerProps = {
  title?: string
  description?: string
  buttonLabel?: string
  className?: string
  onClick?: () => void
}

export default function InstantConsultationBanner({
  title = 'Precisa de atendimento agora?',
  description = 'Conecte-se imediatamente com um especialista em cannabis medicinal.',
  buttonLabel = 'Consultar agora',
  className = 'mb-4',
  onClick
}: InstantConsultationBannerProps) {
  const history = useHistory()

  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }

    history.push('/consulta-na-hora')
  }

  return (
    <div
      className={`${className} flex items-center justify-between gap-4 rounded-2xl bg-gradient-to-r from-primary-700 to-primary-600 px-5 py-4 shadow-sm`}>
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-2 text-base font-bold text-white">
          <Zap size={18} className="text-yellow-300" />
          {title}
        </span>
        <span className="text-xs text-white/80">{description}</span>
      </div>

      <button
        type="button"
        onClick={handleClick}
        className="shrink-0 rounded-lg border border-solid bg-white px-4 py-2 text-sm font-semibold text-primary-700 shadow transition-colors hover:bg-primary-50">
        {buttonLabel}
      </button>
    </div>
  )
}
